import { queryOptions } from '@tanstack/react-query';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

const method = api.getLoansGuarantorliabilityByContractId;

export type GetGuarantorLiabilityQueryParams = {
  contractId: string | null | undefined;
  fromDate?: string;
};

function getGuarantorLiabilityQuery(
  params: GetGuarantorLiabilityQueryParams,
  opts: RequestOpts = {},
) {
  const queryKey = [
    'get-guarantor-liability',
    params.contractId,
    params.fromDate,
  ];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      if (!params.contractId) {
        throw new TypeError('Contract ID is required');
      }
      return method(
        params.contractId,
        { fromDate: params.fromDate },
        { ...opts, signal },
      );
    },
  });
}

export async function fetchGuarantorLiabilityQuery(
  params: GetGuarantorLiabilityQueryParams,
  opts: RequestOpts = {},
) {
  return queryClient.fetchQuery(getGuarantorLiabilityQuery(params, opts));
}
